export enum SelectedTab {
  EDIT = "edit",
  IMAGE = "image",
  TEMPLATE = "template",
  VIDEO = "video"
}
